export default "__VITE_ASSET__ekpStsS8__"